import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const LocationIcon = (props: SvgProps) => (
  <Svg
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <Path
      fill="#0058AD"
      fillRule="evenodd"
      d="M38.8 28a17.421 17.421 0 0 0 2.2-8.5C41 9.835 33.165 2 23.5 2S6 9.835 6 19.5c0 3.085.798 5.983 2.2 8.5 2.378 4.272 10.66 12.51 13.943 15.697a1.938 1.938 0 0 0 2.714 0C28.14 40.51 36.423 32.272 38.8 28Zm-15.3-3a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default LocationIcon;
